import axios from "~/plugins/axios";

export default {
  search(postalCode, houseNumber, houseLetter, houseAddition) {
    const url = "/web_api/v1/address/search";

    return axios.post(url, {
      postalCode,
      houseNumber,
      houseLetter,
      houseAddition,
    }).then((response) => response.data);
  },
};
